export const LANDING_PAGE = '/';
export const MENU_PAGE = '/menu';
export const ORDER_PAGE = '/order';
export const OUR_SERVICES_PAGE = ' /ourservices';
